import { render } from "./BOM.vue?vue&type=template&id=5dbd3805&scoped=true"
import script from "./BOM.vue?vue&type=script&lang=js"
export * from "./BOM.vue?vue&type=script&lang=js"

import "./BOM.vue?vue&type=style&index=0&id=5dbd3805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbd3805"]])

export default __exports__